<template>
  <div class="wrap">

    <Head />
    <div class="part1">
      <p class="tit">区块链线上交易平台</p>
      <p class="txt">基于区块链技术建立安全、可靠、高效的分布式资产交易产业生态</p>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/part1-1.png"
          alt=""
        >
      </div>
    </div>

    <div class="part2">
      <p class="tit">方案介绍</p>
      <div
        class="show"
        id="show"
        style="height:auto"
      >
        <div class="line">
          对于传统交易模式，资产流通必须依赖资产发行方系统，流通范围局限于发行方系统用户内。恒为利用区块链技术将资产流通由原来的中心化控制转变为社会化流通，任何有资源的渠道都可以成为资产流通的催化剂。
        </div>
        <div class="line">
          恒为区块链线上交易平台，通过建立分布式交易市场，使得平台管理方、买方和发行方能够以各自的身份加入本平台系统。平台支持数字资产交易（如OTC交易、合约交易等）、实物资产交易等多种交易模式，采用最新撮合交易+点对点方案，提供快速秒级交易引擎，安全、稳定、可靠。平台管理方负责系统的维护与运营，大大降低客户接入系统的成本。
        </div>
        <div class="line">
          恒为区块链线上交易平台，利用区块链“交易即结算”的基本特性使得实时清算成为可能，大幅提高交易处理效率，实现资产流通情况的实时查询。在资产发行与流通网络中，通过区块链实现资产登记、交易确认、记账对账和清算等功能。
        </div>
         <div class="line">
          方案适用于数字资产交易、能源交易、版权交易、奢侈品交易、艺术品交易、精准扶贫等众多场景。
        </div>
      </div>
      <div
        class="btn"
        v-show="show"
      >
        <div class="btn">
          <p
            @click="getChange('more')"
            v-show="more"
          >
            <span>查看更多</span>
            <i class="iconfont  iconxia"></i>
          </p>
          <p
            @click="getChange('less')"
            v-show="!more"
          >
            <span>收起</span>
            <i class="iconfont  iconshang"></i>
          </p>
        </div>
      </div>
      <div class="img">
        <img
          src="../../../assets/images/mobile/solution/onlineTrad/part2.png"
          alt=""
        >
      </div>

    </div>

    <div class="part3">
      <p class="tit">方案价值</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/onlineTrad/part3-1.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">平台管理方受益</p>
            <p class="text">
              基于区块链的分布式技术特性，恒为区块链线上交易平台天然地具有安全、可靠、可信任属性。平台线上交易真实有效、可查询追溯，能有效解决传统交易平台数据不透明、数据造假、中心化平台易受攻击等问题，极大地降低了投资风险
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/onlineTrad/part3-2.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">发行方受益</p>
            <p class="text">
              将拥有更多的发行资产受众，资产上链，确保了资产的唯一性；智能合约撮合交易实现变现，每笔交易链上可查，避免纠纷；秒级交易“实时结算”，有效解决对账繁琐、效率低等问题
            </p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/solution/onlineTrad/part3-3.png"
              alt=""
            >
          </div>
          <div class="right">
            <p class="title">买方受益</p>
            <p class="text">
              资产转账速度快，仅需3-资产信息真实可靠，交易透明、可追溯
            </p>
          </div>
        </div>
      </div>

    </div>


    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {
      show: false,
      more: true,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  mounted() {
    this.getShow();
  },
  methods: {
    //判断是否显示加载更多
    getShow() {
      let h = document.getElementById("show").offsetHeight;
      let w = document.body.clientWidth;
      if (h > w * 0.31) {
        this.show = true;
        document.getElementById("show").style.height = "30vw";
      } else {
        this.show = false;
      }
    },
    getChange(type) {
      if (type == "more") {
        this.more = false;
        document.getElementById("show").style.height = "auto";
      } else {
        this.more = true;
        document.getElementById("show").style.height = "30vw";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);

  background: linear-gradient(-30deg, #019EDF, #1CC8E7);
  position: relative;
  part1();
  padding-top: vw(57);

  .tit {
    margin-bottom: vw(22);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
    padding: 0 vw(80);
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(20);
    text-align: center;

    img {
      width: vw(440);
      height: vw(351);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .show {
    overflow: hidden;
    transition: all 0.3s ease;

    .line {
      font-size: vw(28);
      color: #666666;
      line-height: vw(48);
      margin-bottom: vw(30);
      padding: 0 vw(30);
    }
  }

  .btn {
    margin-top: vw(40);

    p {
      width: vw(240);
      height: vw(80);
      background: #fff;
      border-radius: vw(40);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      margin: 0 auto;

      span {
        display: inline-block;
        height: vw(80);
        color: #2A93FF;
        font-size: vw(30);
        line-height: vw(80);
      }

      i {
        margin-left: vw(5);
        display: inline-block;
        height: vw(80);
        font-size: vw(24);
        color: #2A93FF;
        line-height: vw(80);
      }
    }
  }

  .img {
    margin-top: vw(60);
    text-align: center;

    img {
      width: vw(690);
      height: auto;
    }
  }
}

.part3 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(241);
      margin: 0 auto vw(30);
      padding: vw(44) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);
        padding-top: vw(14);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
          showline(3)
        }
      }
    }
  }
}

.part4 {
  part();
  background: #fff;
  padding: vw(80) 0 vw(40);

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .card {
    width: vw(690);
    padding: vw(20);
    margin: 0 auto vw(40);
    background: #fff;
    box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

    .img {
      text-align: center;

      img {
        width: vw(650);
        height: auto;
      }
    }

    .content {
      margin-top: vw(60);

      .title {
        font-size: vw(32);
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: vw(32);
        margin-bottom: vw(30);
        text-align: center;
      }

      .line {
        font-size: vw(24);
        color: #888888;
        line-height: vw(36);
        margin-bottom: vw(40);
      }
    }
  }
}
</style>
